import React, { Component, Fragment } from "react";
import {
  Button,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Glyphicon,
  Modal,
} from "react-bootstrap";
import { ErrorMessage, Field, FieldArray, Formik, Form } from "formik";
import uuidv4 from "uuid/v4";
import * as Yup from "yup";

import { Input } from "../../FormControls";
import { FormMode } from "../../../constant";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Group Name is required."),
  versions: Yup.array().of(
    Yup.object().shape({
      value: Yup.string().required("Value is required."),
    })
  ),
});

export function NewMatchListModal({
  show,
  formMode,
  selectedGroupValue,
  onFormSubmit,
  onModalClose,
}) {
  return (
    <Modal show={show} onHide={onModalClose} backdrop="static">
      <Modal.Header>
        <Modal.Title>
          {formMode === FormMode.Add ? "New Group Values" : "Edit Group Values"}
        </Modal.Title>
      </Modal.Header>
      <Formik
        initialValues={selectedGroupValue}
        validationSchema={validationSchema}
        onSubmit={onFormSubmit}
      >
        {({ handleSubmit, isSubmitting, values }) => (
          <Fragment>
            <Modal.Body>
              <Form className="form-horizontal">
                <Input
                  col={9}
                  label={{ col: 3, text: "Group Name" }}
                  name="name"
                />
                <GroupValues name="versions" items={values.versions} />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                className="btn btn-grey"
                disabled={isSubmitting}
                onClick={onModalClose}
              >
                Close
              </button>
              <Button
                bsStyle="primary"
                disabled={isSubmitting}
                onClick={handleSubmit}
              >
                Save {isSubmitting && <i className="fa fa-spinner fa-spin" />}
              </Button>
            </Modal.Footer>
          </Fragment>
        )}
      </Formik>
    </Modal>
  );
}

function GroupValues({ name, items }) {
  return (
    <FieldArray name={name}>
      {({ push, remove, form: { touched, errors } }) => (
        <FormGroup
          controlId={name}
          validationState={touched[name] && errors[name] ? "error" : null}
        >
          <Col componentClass={ControlLabel} sm={3}>
            Values
          </Col>
          <Col className="repeater" sm={9}>
            {items.map((item, index) => (
              <Fragment key={item.id}>
                <div className={index != 0 ? "input-group" : undefined}>
                  <FormControl
                    type="text"
                    componentClass={Field}
                    name={`${name}[${index}].value`}
                  />
                  {index !== 0 && (
                    <div className="input-group-btn">
                      <Button bsStyle="danger" onClick={() => remove(index)}>
                        <Glyphicon glyph="remove" />
                      </Button>
                    </div>
                  )}
                </div>
                <ErrorMessage
                  component="div"
                  className="error text-danger"
                  name={`${name}[${index}].value`}
                />
              </Fragment>
            ))}
            <Button
              bsSize="small"
              bsStyle="primary"
              onClick={() =>
                push({ id: uuidv4(), value: "", isNew: true, isDeleted: false })
              }
            >
              <Glyphicon glyph="plus" /> Add
            </Button>
          </Col>
        </FormGroup>
      )}
    </FieldArray>
  );
}
